module.exports = __webpack_public_path__ + "static/media/AdminProfileCoverImage.91c355b2.png";